import React from "react";
import OnboardingCard from "../../components/OnboardingComponents/OnboardingCard";
import OnboardingButton from "../../components/OnboardingComponents/OnboardingButton";

interface LogoutModalProps {
  showLogoutModal: boolean;
  setShowLogoutModal: (show: boolean) => void;
  handleLogout: () => void;
  isLoading?: boolean;
}

export const LogoutModal = ({ 
  showLogoutModal, 
  setShowLogoutModal, 
  handleLogout,
  isLoading = false
}: LogoutModalProps) => {
  if (!showLogoutModal) return null;

  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-[#030724]/40 backdrop-blur-sm p-4">
      <div className="w-full max-w-md">
        <OnboardingCard className="p-10 flex flex-col">
          <h3 className="font-['Canela_Text'] text-[28px] font-bold text-[#030724] text-center">
            Log Out
          </h3>
          <p className="mt-4 font-['Proxima_Nova'] text-lg text-center text-[#46464D]">
            Are you sure you want to log out from your master account?
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <div className="flex-1">
              <OnboardingButton
                title="CANCEL"
                variant="outline"
                onClick={() => setShowLogoutModal(false)}
                disabled={isLoading}
              />
            </div>
            <div className="flex-1">
              <OnboardingButton
                title="LOG OUT"
                variant="filled"
                onClick={handleLogout}
                loading={isLoading}
              />
            </div>
          </div>
        </OnboardingCard>
      </div>
    </div>
  );
};